import { render, staticRenderFns } from "./Part4.vue?vue&type=template&id=fd65c340&scoped=true"
import script from "./Part4.vue?vue&type=script&lang=js"
export * from "./Part4.vue?vue&type=script&lang=js"
import style0 from "./Part4.vue?vue&type=style&index=0&id=fd65c340&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd65c340",
  null
  
)

export default component.exports